<script setup lang="ts">
  /**
   * Back link — 03-components/24-back-link · OSCloud DS 1.1.27
   */
  import type { RouteLocationRaw } from 'vue-router'

  import BfIconArrowLeft from '@/components/ui/icons/BfIconArrowLeft.vue'

  defineProps<{ to: RouteLocationRaw }>()
</script>

<template>
  <router-link :to="to" class="back-link">
    <BfIconArrowLeft class="back-link__icon" :size="15" />
    <slot />
  </router-link>
</template>

<style scoped lang="scss">
  .back-link {
    display: flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    margin: 0 0 12px;
    font-family: var(--bf-font-display);
    font-size: var(--bf-fs-xs_5);
    font-weight: var(--bf-fw-semibold);
    line-height: 1.25;
    letter-spacing: 0;
    text-transform: none;
    color: var(--bf-orange-dark);
    text-decoration: none;
    transition: color var(--bf-dur-base) var(--bf-ease);

    &:hover {
      color: var(--bf-orange-dark);
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    &:focus-visible {
      outline: 2px solid var(--bf-orange-dark);
      outline-offset: 3px;
      border-radius: var(--bf-r-sm);
    }

    /* 15px, currentColor — the arrow always matches the label, including in the
       focus and hover states and on a dark surface. */
    &__icon {
      flex: none;
      width: 15px;
      height: 15px;
      color: currentColor;
    }
  }
</style>
